import { View, Text, styled } from 'tamagui'
import { ShieldCheck } from '@tamagui/lucide-icons'
import { useAppStore } from '@/store'
import type { HomeTab } from '@/store'
import { YourServersGrid } from './YourServersGrid'
import { ExploreView } from './ExploreView'

const Container = styled(View, {
  flex: 1,
  flexDirection: 'column',
  backgroundColor: '$surface',
})

const Header = styled(View, {
  paddingHorizontal: 24,
  paddingTop: 16,
  paddingBottom: 0,
  borderBottomWidth: 1,
  borderBottomColor: '$borderDefault',
})

const Title = styled(Text, {
  fontFamily: '$fontHeading',
  fontWeight: '700',
  fontSize: 22,
  color: '$surfaceForeground',
  marginBottom: 16,
})

const TabBar = styled(View, {
  flexDirection: 'row',
  gap: 0,
})

const Tab = styled(View, {
  paddingHorizontal: 16,
  paddingVertical: 10,
  cursor: 'pointer',
  borderBottomWidth: 2,
  borderBottomColor: 'transparent',
  // @ts-expect-error -- web transition
  style: { transition: 'border-color 150ms ease' },
  variants: {
    active: {
      true: {
        borderBottomColor: '$accent',
      },
    },
  } as const,
})

const TabText = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 14,
  fontWeight: '500',
})

const Content = styled(View, {
  flex: 1,
  overflow: 'hidden',
})

const tabs: { id: HomeTab; label: string }[] = [
  { id: 'your-servers', label: 'Your Servers' },
  { id: 'explore', label: 'Explore' },
]

export function HomeDashboard() {
  const { homeTab, setHomeTab } = useAppStore()

  return (
    <Container>
      <Header>
        <View flexDirection="row" alignItems="center" justifyContent="space-between">
          <Title>Home</Title>
          <View flexDirection="row" alignItems="center" gap={8} backgroundColor="$accentLighter" borderRadius={8} paddingHorizontal={12} paddingVertical={6} borderWidth={1} borderColor="$accent">
            <ShieldCheck size={16} color="$accent" />
            <View>
              <Text fontFamily="$fontBody" fontSize={12} fontWeight="600" color="$surfaceForeground">No ID Verification Required</Text>
              <Text fontFamily="$fontBody" fontSize={10} color="$sidebarMuted">E2E encrypted — your privacy matters</Text>
            </View>
          </View>
        </View>
        <TabBar>
          {tabs.map((tab) => (
            <Tab key={tab.id} active={homeTab === tab.id} onPress={() => setHomeTab(tab.id)}>
              <TabText color={homeTab === tab.id ? '$accent' : '$sidebarMuted'}>
                {tab.label}
              </TabText>
            </Tab>
          ))}
        </TabBar>
      </Header>

      <Content>
        {homeTab === 'your-servers' ? <YourServersGrid /> : <ExploreView />}
      </Content>
    </Container>
  )
}
